module.exports = __webpack_public_path__ + "img/PLAY.997082a0.png";